var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlarmBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F8B091",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32v-.68c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-2.86.68-4.5 3.24-4.5 6.32v5l-2 2v1h16v-1l-2-2zm-2 1h-8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z",
    fill: "#F06223"
  })));
}

export default __webpack_public_path__ + "6f59a50f1797935e51edb40457b95fca.svg";
export { SvgAlarmBell as ReactComponent };